import { useEffect, useState } from 'react'
import {
  AGENT_PANEL_VISIBILITY_EVENT,
  getAgentPanelVisibleFromStorage,
  type AgentPanelVisibilityDetail,
} from '@/lib/agent-panel-visibility'

/** True when the right agent chat panel is shown and expanded (not strip-collapsed). */
export function useAgentPanelVisible(): boolean {
  const [visible, setVisible] = useState(() => getAgentPanelVisibleFromStorage())

  useEffect(() => {
    const onVisibility = (event: Event) => {
      const detail = (event as CustomEvent<AgentPanelVisibilityDetail>).detail
      if (typeof detail?.visible === 'boolean') setVisible(detail.visible)
    }
    const onStorage = (event: StorageEvent) => {
      if (
        event.key === null ||
        event.key.includes('ui_show_agent') ||
        event.key.includes('ui_agent_collapsed')
      ) {
        setVisible(getAgentPanelVisibleFromStorage())
      }
    }
    window.addEventListener(AGENT_PANEL_VISIBILITY_EVENT, onVisibility)
    window.addEventListener('storage', onStorage)
    setVisible(getAgentPanelVisibleFromStorage())
    return () => {
      window.removeEventListener(AGENT_PANEL_VISIBILITY_EVENT, onVisibility)
      window.removeEventListener('storage', onStorage)
    }
  }, [])

  return visible
}
